/**
 * A string representing a bounding rectangle
 * @param {DOMRectReadOnly}
 */
export const coordinatesString = ({
    x,
    y,
    width: w,
    height: h,
}: DOMRect): string =>
    [x, y, w, h].every(Number.isFinite) ? `[x${x} y${y} w${w} h${h}]` : "";
